import { setToggle } from '@st/util/array-set'

import { useSelect } from '~/store'

import { Folder } from '@st/sdk'
import { Button, Dialog, DialogButtons, GearIcon, SelectableTagOption } from '@st/theme'
import { setDiff } from '@st/util/array-set'
import { useState } from 'react'
import { useSetRoute } from '../app-hooks'
import {
  selOrganizationActiveFolderTags,
  stOrganizationModule
} from '../st-organizations/st-organization-module'

export function EditFolderTagsDialog({
  folderId,
  tagIds,
  folderName,
  onSave,
  onClose
}: {
  folderId: string
  tagIds: Folder['tagIds']
  folderName: string
  onSave: (params: { folderId: string; addTagIds: string[]; removeTagIds: string[] }) => void
  onClose: () => void
}) {
  const setRoute = useSetRoute()

  const tags = useSelect('stOrganization', selOrganizationActiveFolderTags)

  const [editedTagIds, setEditedTagIds] = useState(tagIds)

  if (tags.length == 0) {
    return (
      <Dialog
        title="Add tags"
        subtitle="You haven't created any tags yet. To manage tags go to Settings → Tags, or just click the “Manage tags” button."
        buttons={
          <DialogButtons>
            <Button variant="default" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              leadingIcon={<GearIcon className="h-4 w-4" />}
              onClick={() => setRoute({ name: 'manage_organization_tags' })}
            >
              Manage tags
            </Button>
          </DialogButtons>
        }
      />
    )
  }

  return (
    <Dialog
      title={`Add tags for ${folderName}`}
      subtitle={`Add any of the following tags. You can manage your tags in Settings.`}
      buttons={
        <DialogButtons>
          <Button variant="subtle" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              const diff = setDiff({ old: tagIds, new: editedTagIds })
              // nothing to change
              if (diff.add.length == 0 && diff.remove.length == 0) {
                onClose()
                return
              }

              onSave({ folderId, addTagIds: diff.add, removeTagIds: diff.remove })

              onClose()
            }}
          >
            Save
          </Button>
        </DialogButtons>
      }
    >
      <div className="flex flex-col gap-2">
        {tags.map((t) => {
          return (
            <SelectableTagOption
              key={t.id}
              color={t.color}
              selected={editedTagIds.includes(t.id)}
              onClick={() => setEditedTagIds(setToggle(editedTagIds, t.id))}
            >
              {t.label}
            </SelectableTagOption>
          )
        })}
      </div>
    </Dialog>
  )
}
